export function buildQueryString(params: object): string {
  const entries = Object.entries(
    params as Record<string, string | number | boolean | undefined>,
  ).filter(([, v]) => v !== undefined && v !== '')
  if (entries.length === 0) return ''
  return (
    '?' +
    entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join('&')
  )
}
